import React from "react";

const getSize = () =>{

    console.log("onload");

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);    

    console.log("HOA", vh);

    window.addEventListener('resize', () => {
        // We execute the same script as before
        vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);

        console.log("resized");
      });

    return <></>
}


export default getSize;